export default "__VITE_ASSET__DgS3iCZT__"